import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVocalMicrophone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVocalMicrophone"><Path d="M14.75 13.25L5.5 21.5L2.5 18.5L10.75 9.25L14.75 13.25Z" fill="currentColor"/><Path d="M16.5 2.5C19.2614 2.5 21.5 4.73858 21.5 7.5C21.5 10.2614 19.2614 12.5 16.5 12.5C16.3004 12.5 16.1036 12.4886 15.9102 12.4658L11.5342 8.08984C11.5114 7.8964 11.5 7.69955 11.5 7.5C11.5 4.73858 13.7386 2.5 16.5 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVocalMicrophone;
